import PersonalAccountBeneficiaryApiClient from "@/api/personalAccountBeneficiaryApiClient";
import { AppToasterV2 } from "@ucl/library";
import { useEffect, useState } from "react";
import { useAuthenticatedApiClient } from "./useAuthenticatedApiClient";
import { PersonalAccountBeneficiary } from "@/types/PersonalAccountBeneficiary";

export const usePersonalAccountBeneficiariesSummary = (financialApplicationId: string) => {
  const [personalAccountBeneficiaries, setPersonalAccountBeneficiaries] = useState<PersonalAccountBeneficiary[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const personalAccountBeneficiaryApiClient = useAuthenticatedApiClient(PersonalAccountBeneficiaryApiClient);

  useEffect(() => {
    getPersonalAccountBeneficiaries();
  }, [financialApplicationId]);

  const getPersonalAccountBeneficiaries = async () => {
    setIsLoading(true);
    try {
      const beneficiaries = await personalAccountBeneficiaryApiClient.getPersonalAccountBeneficiaries(financialApplicationId);
      setPersonalAccountBeneficiaries(beneficiaries);
    } catch (error) {
      console.error(error);
      AppToasterV2.showFailedActionToaster("Failed to get personal account beneficiaries.");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    personalAccountBeneficiaries,
    isLoading,
    getPersonalAccountBeneficiaries,
  };
};
